import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import FileSaver from 'file-saver'

import ExpertRoutesSearchForms from './expertroutessearch-form'
import ExpertRouteSentRepository from '@/shared/http/repositories/regulation/expertroutes/expertroutes.js'
import ExpertRouteViewRepository from '@/shared/http/repositories/regulation/expertroutes/expertrouteview.js'

import AccountMixin from '@/store/module/account/mixin'
import InsuranceMixin from '@/store/module/insurance/mixin.js'
import StageMixin from '@/store/module/stage/mixin.js'
import ExpertMixin from '@/store/module/expert/mixin.js'
import AnalystMixin from '@/store/module/analyst/mixin.js'
import RegulationMixin from '@/store/module/regulation/mixin'
import RegulationTypeMixin from '@/store/module/regulationtype/mixin'
import SchedulingTypeMixin from '@/store/module/schedulingtype/mixin'
import BudgetSystemMixin from '@/store/module/budgetsystem/mixin.js'
import { actionTypes as RegulationActions } from '@/store/module/regulation/actions'
import { globalMutationTypes as RegulationMutations } from '@/store/module/regulation/mutations'

import Datepicker from 'vuejs-datepicker'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

const dataSearch = {
  insurance: null,
  insured: null,
  stage: null,
  sinisterCode: null,
  sinisterVersion: null,
  expert: null,
  expertID: null,
  analyst: null,
  sinisterDateStart: null,
  sinisterDateEnd: null,
  lighthouse: null,
  plate: null,
  ranking: null,
  regulationType: null,
  schedulingType: null,
  budgetSystem: null
}

window.FileSaver = FileSaver

export default {
  name: 'ExpertRoutesSearch',
  mixins: [
    ActionsForm,
    InsuranceMixin,
    StageMixin,
    ExpertMixin,
    AnalystMixin,
    RegulationMixin,
    AccountMixin,
    RegulationTypeMixin,
    SchedulingTypeMixin,
    BudgetSystemMixin
  ],
  data () {
    return {
      data: dataSearch,
      form: ExpertRoutesSearchForms,
      en: en,
      es: es,
      ptBR: ptBR
    }
  },
  components: {
    Datepicker
  },
  mounted () {
    this.form.sinisterDateStart.value = this.moment().format()
    this.form.sinisterDateEnd.value = this.moment().format()
    this.$refs.tableGrid.cbxItemPerPage = 500
    this.$refs.tableGrid.pagingLimit = 500
  },
  computed: {
    getAllInsurer: function () {
      var result = []
      if ((this.insurances) && (this.insurances.count) > 0) {
        var data = this.insurances.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.insurance.options = result
      }
      return result
    },
    getAllStage: function () {
      var result = []
      var STG_SCHEDULED = []

      if ((this.stages) && (this.stages.count) > 0) {
        var data = this.stages.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
            if (data[i].mnemonic === 'STG_SCHEDULED' || data[i].mnemonic === 'STG_REGULATION') {
              STG_SCHEDULED.push({ 'label': data[i].name, 'value': data[i].id })
            }
          }
        }
        this.form.stage.options = result

        var self = this
        setTimeout(() => self.setStage(STG_SCHEDULED), 1000)
      }
      return result
    },
    getAllExpert: function () {
      var result = []
      if ((this.experts) && (this.experts.count) > 0) {
        var data = this.experts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.expert.options = result
      }
      return result
    },
    getAllAnalyst: function () {
      var result = []
      if ((this.analysts) && (this.analysts.count) > 0) {
        var data = this.analysts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.analyst.options = result
      }
      return result
    },
    getAllRegulationType: function () {
      var result = []
      if ((this.regulationtypes) && (this.regulationtypes.count) > 0) {
        var data = this.regulationtypes.data
        result = data.filter(d => d.status)
          .map(d => ({ 'label': d.name, 'value': d.id }))
        this.form.regulationType.options = result
      }
      return result
    },
    getAllSchedulingType: function () {
      var result = []
      if ((this.schedulingtypes) && (this.schedulingtypes.count) > 0) {
        var data = this.schedulingtypes.data
        result = data.filter(d => d.status)
          .map(d => ({ 'label': d.name, 'value': d.id }))
      }
      return result
    },
    getAllBudgetSystem: function () {
      var result = []
      if ((this.budgetsystems) && (this.budgetsystems.count) > 0) {
        var data = this.budgetsystems.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.budgetSystem.options = result
      }
      return result
    }
  },
  methods: {
    Clear () {
      this.onClear()
    },
    onClearAllTabs () {
      this.$store.commit(RegulationMutations.SET_REGULATION, {})
      this.$emit('ClearTabs', this.onClear())
      setTimeout(() => {
        this.$emit('MoveTabIndex')
      }, 400)
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.$refs.tableGrid.Clear(null)
      this.reloadState()
    },
    onLoad () {
      this.getAllInsuranceByArea(process.env.AreaAutos)
      this.getAllStageByArea(process.env.AreaAutos)
      this.getAllExpertByArea(process.env.AreaAutos)
      this.getAllRegulationTypeByArea(process.env.AreaAutos)
      this.getAllSchedulingTypes()
      this.getAllBudgetSystems()
    },
    onSearch () {
      var self = this
      if (Tools.ValidateForms(this.form, this.data, self)) {
        loading.push()
        ExpertRouteViewRepository.SearchPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.data)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
      this[RegulationActions.GET_BY_ID](obj.id)
        .then((response) => {
        })
    },
    onCheck (e) {
      var checked = e.target.checked
      var regulationAutoSchedulingID = e.target.value
      for (var i in this.objList) {
        if (this.objList[i].regulationAutoSchedulingID === regulationAutoSchedulingID) {
          this.objList[i].checked = checked
        }
      }
    },
    onFullscreen () {
      if (this.$refs.frmSinister.showForm) {
        this.$refs.frmSinister.showForm = false
      } else {
        this.$refs.frmSinister.showForm = true
      }
    },
    onExport () {
      var self = this
      if (Tools.ValidateForms(this.form, this.data, self)) {
        if (this.data != null) {
          loading.push()
          ExpertRouteViewRepository.Export(this.data)
            .then((response) => {
              var result = response.data
              if (result.code === 0) {
                const s2ab = (s) => {
                  var buf = new ArrayBuffer(s.length)
                  var view = new Uint8Array(buf)
                  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
                  return buf
                }
                const blob = new Blob([s2ab(atob(result.data.file))], { type: result.data.contentType })
                FileSaver.saveAs(blob, result.data.fileName)
              } else {
                var alertMessage = self.$lang.Common.Alerts.RequiredDate
                self.$refs.alert.ShowAlert('warning', alertMessage)
              }
              loading.pop()
            })
            .catch((err) => {
              this.onException(err)
              loading.pop()
            })
        }
      }
    },
    reloadState () {
      var result = []
      var STG_SCHEDULED = []

      if ((this.stages) && (this.stages.count) > 0) {
        var data = this.stages.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
            if (data[i].mnemonic === 'STG_SCHEDULED' || data[i].mnemonic === 'STG_REGULATION') {
              STG_SCHEDULED.push({ 'label': data[i].name, 'value': data[i].id })
            }
          }
        }
        this.form.stage.options = result
        this.setStage(STG_SCHEDULED)
      }
    },
    setStage (data) {
      this.form.stage.value = data
    },
    onSendEmail () {
      loading.push()
      var listData = []
      for (var i in this.objList) {
        if (this.objList[i].checked) {
          listData.push(this.objList[i])
        }
      }
      listData.sort(this.sortExpertNameAsc)
      var dataToSend = this.getDataByExpert(listData, this.getExpertList(listData))
      if (dataToSend && dataToSend.length > 0) {
        ExpertRouteSentRepository.SendEmail(dataToSend)
          .then((response) => {
            setTimeout(() => {
              loading.close()
              toast.success('Envio inciado com sucesso!<br> Realize a pesquisa novamente para acompanhar os envios dos emails')
              // this.onSearch()
            }, 5000)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        loading.close()
        toast.warning('Você precisa selecionar alguma vistoria para enviar o email')
      }
    },
    sortExpertNameAsc (a, b) {
      // Use toUpperCase() to ignore character casing
      const nameA = a.expertName.toUpperCase()
      const nameB = b.expertName.toUpperCase()

      let comparison = 0
      if (nameA > nameB) {
        comparison = 1
      } else if (nameA < nameB) {
        comparison = -1
      }
      return comparison
    },
    getExpertList (data) {
      var experts = []
      // var newList = []
      for (var i in data) {
        if (experts.length === 0) {
          experts.push({'expertID': data[i].expertID, 'expertName': data[i].expertName})
        } else {
          var hasExpet = experts.filter(x => x.expertID === data[i].expertID)
          if (hasExpet.length === 0) {
            experts.push({'expertID': data[i].expertID, 'expertName': data[i].expertName})
          }
        }
      }
      return experts
    },
    getDataByExpert (data, experts) {
      var newList = []
      for (var i in experts) {
        var list = data.filter(x => x.expertID === experts[i].expertID)
        newList.push({'expertID': experts[i].expertID, 'expertName': experts[i].expertName, 'data': list})
      }
      return newList
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/expertroutes/search/expertroutessearch.js